var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomHealthInsurance = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    fillRule: "nonzero",
    d: "M14.759 3.03c.14-.04.289-.04.429 0l9.85 2.739c.308.085.536.345.58.661.057.411 1.36 10.119-1.983 14.948-3.34 4.823-8.265 6.059-8.474 6.11-.061.014-.124.022-.188.022-.063 0-.126-.008-.188-.023-.208-.05-5.134-1.286-8.473-6.11C2.968 16.549 4.272 6.842 4.329 6.43c.044-.316.271-.576.579-.661zm1.67 6.97H13.57c-.396 0-.71.315-.71.71v2.15h-2.15c-.395 0-.71.314-.71.71v2.86c0 .396.315.71.71.71h2.15v2.15c0 .395.314.71.71.71h2.86c.097 0 .194-.016.274-.057.21-.088.372-.282.42-.508.008-.049.017-.097.017-.146v-2.148h2.148c.396 0 .711-.315.711-.711v-2.86c0-.396-.323-.71-.719-.71h-2.14v-2.15c0-.395-.315-.71-.711-.71z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomHealthInsurance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-health-insurance.8cfc4d2a53bdf5c661525698db1a9487.svg";